export default "__VITE_ASSET__Bmpc0Hsa__"